// extracted by mini-css-extract-plugin
export default {"heroHeader":"AcademyGown_heroHeader__pmX7n","adj1":"AcademyGown_adj1__QuLYd","adj2":"AcademyGown_adj2__CO6sj","adj3":"AcademyGown_adj3__h8tm6","kernA":"AcademyGown_kernA__hel6C"};